export default __webpack_public_path__ + "static/media/youtube.13fd684c.svg";